import { render, staticRenderFns } from "./problemRectify.vue?vue&type=template&id=6a7d2cbd&scoped=true"
import script from "./problemRectify.vue?vue&type=script&lang=js"
export * from "./problemRectify.vue?vue&type=script&lang=js"
import style0 from "./problemRectify.vue?vue&type=style&index=0&id=6a7d2cbd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7d2cbd",
  null
  
)

export default component.exports